import { render, staticRenderFns } from "./TitleSection.vue?vue&type=template&id=060e1d10&name=title-section&"
import script from "./TitleSection.vue?vue&type=script&lang=js&"
export * from "./TitleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports